import { Component, Input } from '@angular/core';

@Component({
  selector: 'vc-svg-cart-payment',
  templateUrl: './svg-cart-payment.component.html',
  styleUrls: ['./svg-cart-payment.component.scss']
})
export class SvgCartPaymentComponent {
  @Input()
  payment: string;

  constructor() {}
}
